module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='    <thead>\n      <th>Vote Date</th>\n      <th>Description</th>\n      <th>Yeas</th>\n      <th>Nays</th>\n      <th>Not<br/>Voting</th>\n      <th>Excused</th>\n    </thead>\n    <tbody></tbody>\n';
}
return __p;
};
